import { FormattedMessage } from 'react-intl';
import { SavingState } from '../../getSavingState';

type AddFileButtonLabelProps = {
  savingState: SavingState;
};

const AddFileButtonLabel = ({ savingState }: AddFileButtonLabelProps) => {
  if (savingState === SavingState.BOTH) {
    return (
      <FormattedMessage id="portfolio.challenge.files.add.button.saving_labels.saving_generic" />
    );
  }

  if (savingState === SavingState.IMAGES) {
    return (
      <FormattedMessage id="portfolio.challenge.files.add.button.saving_labels.saving_images" />
    );
  }

  if (savingState === SavingState.EXTERNAL_FILES) {
    return (
      <FormattedMessage id="portfolio.challenge.files.add.button.saving_labels.saving_external_files" />
    );
  }

  return (
    <FormattedMessage id="portfolio.challenge.files.add.button.add_label" />
  );
};

export default AddFileButtonLabel;
